/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const MessagingConsentStatus = {
  OptedIn: "opted_in",
  OptedOut: "opted_out",
} as const;
export type MessagingConsentStatus =
  (typeof MessagingConsentStatus)[keyof typeof MessagingConsentStatus];

export function instanceOfMessagingConsentStatus(value: any): boolean {
  for (const key in MessagingConsentStatus) {
    if (Object.prototype.hasOwnProperty.call(MessagingConsentStatus, key)) {
      if (
        MessagingConsentStatus[key as keyof typeof MessagingConsentStatus] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function MessagingConsentStatusFromJSON(
  json: any
): MessagingConsentStatus {
  return MessagingConsentStatusFromJSONTyped(json, false);
}

export function MessagingConsentStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingConsentStatus {
  return json as MessagingConsentStatus;
}

export function MessagingConsentStatusToJSON(
  value?: MessagingConsentStatus | null
): any {
  return value as any;
}

export function MessagingConsentStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): MessagingConsentStatus {
  return value as MessagingConsentStatus;
}
